(function () {
  const FORM_SELECTOR = '[data-pcard-add-form]';
  const BUTTON_SELECTOR = '.pcard-add__btn';
  const FLY_ANIMATION_TIMEOUT = 3200;

  if (!window.__productCardAddBootstrap) {
    document.addEventListener(
      'pointerdown',
      (event) => {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;

        const form = getProductCardAddForm(event);
        if (!form) return;

        event.preventDefault();
        event.stopPropagation();
        submitProductCardAddForm(form);
      },
      { capture: true }
    );

    document.addEventListener(
      'click',
      (event) => {
        const form = getProductCardAddForm(event);
        if (!form) return;

        event.preventDefault();
        event.stopPropagation();
        submitProductCardAddForm(form);
      },
      { capture: true }
    );
  }

  document.addEventListener(
    'submit',
    (event) => {
      if (!(event.target instanceof HTMLFormElement) || !event.target.matches(FORM_SELECTOR)) return;

      event.preventDefault();
      event.stopPropagation();
      submitProductCardAddForm(event.target);
    },
    { capture: true }
  );

  /**
   * @param {Event} event
   * @returns {HTMLFormElement | null}
   */
  function getProductCardAddForm(event) {
    if (!(event.target instanceof Element)) return null;

    const button = event.target.closest(BUTTON_SELECTOR);
    const form = button?.closest(FORM_SELECTOR);

    return form instanceof HTMLFormElement ? form : null;
  }

  /**
   * @param {HTMLFormElement} form
   */
  async function submitProductCardAddForm(form) {
    const button = form.querySelector(BUTTON_SELECTOR);
    if (!(button instanceof HTMLButtonElement) || button.disabled || form.dataset.pending === 'true') return;

    const routes = getRoutes();
    form.dataset.pending = 'true';
    button.disabled = true;
    button.classList.add('pcard-add__btn--loading');

    try {
      const response = await fetch(routes.cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(form),
      });

      if (!response.ok) throw new Error('Product card add failed');

      button.classList.remove('pcard-add__btn--loading');
      button.classList.add('pcard-add__btn--success');

      const flyPromise = flyToCart(button);
      const cartResponse = await fetch(routes.cartUrl, { credentials: 'same-origin' });
      const cart = await cartResponse.json();

      await flyPromise;

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'product-card-add-btn',
            data: {
              itemCount: cart.item_count,
              source: 'product-card-add-btn',
            },
          },
        })
      );

      window.setTimeout(() => {
        button.classList.remove('pcard-add__btn--success');
        button.disabled = false;
        delete form.dataset.pending;
      }, 1500);
    } catch (error) {
      console.error(error);
      button.classList.remove('pcard-add__btn--loading');
      button.classList.add('pcard-add__btn--error');

      window.setTimeout(() => {
        button.classList.remove('pcard-add__btn--error');
        button.disabled = false;
        delete form.dataset.pending;
      }, 1500);
    }
  }

  function findCartIcon() {
    const { cartPath } = getRoutes();

    return (
      document.querySelector('cart-icon.header-actions__cart-icon') ||
      document.querySelector(`a[href="${cartPath}"] .svg-wrapper`) ||
      document.querySelector('[data-cart-icon-bubble]') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector(`a[href="${cartPath}"]`) ||
      document.querySelector('[aria-label*="cart" i]') ||
      document.querySelector('[aria-label*="sepet" i]')
    );
  }

  /**
   * @param {HTMLElement} button
   * @returns {Element}
   */
  function findSourceElement(button) {
    const card = button.closest('[data-product-card], .product-card, article, li, .resource-list__item');

    if (card) {
      return (
        card.querySelector('.card-gallery') ||
        card.querySelector('.product-card__image') ||
        card.querySelector('.product-media-container') ||
        card.querySelector('img') ||
        button
      );
    }

    return button;
  }

  /**
   * @param {Element} sourceElement
   * @returns {string | null}
   */
  function findImageUrl(sourceElement) {
    if (sourceElement instanceof HTMLImageElement) {
      return sourceElement.currentSrc || sourceElement.src || null;
    }

    const image = sourceElement.querySelector('img');
    return image instanceof HTMLImageElement ? image.currentSrc || image.src || null : null;
  }

  /**
   * @param {HTMLElement} button
   * @returns {Promise<void>}
   */
  function flyToCart(button) {
    const cartIcon = findCartIcon();
    if (!cartIcon) return Promise.resolve();

    const sourceElement = findSourceElement(button);
    const imageUrl = findImageUrl(sourceElement);
    if (!imageUrl) return Promise.resolve();

    return new Promise((resolve) => {
      let didFinish = false;
      const finish = () => {
        if (didFinish) return;
        didFinish = true;
        clearTimeout(fallbackTimeout);
        resolve();
      };
      const fallbackTimeout = window.setTimeout(finish, FLY_ANIMATION_TIMEOUT);

      customElements.whenDefined('fly-to-cart').then(() => {
        if (didFinish) return;

        const flyElement = document.createElement('fly-to-cart');
        flyElement.classList.add('ptc-fly-to-cart');
        flyElement.style.setProperty('background-image', `url(${imageUrl})`);
        flyElement.useSourceSize = false;
        flyElement.source = sourceElement;
        flyElement.destination = cartIcon;

        flyElement.addEventListener('fly-to-cart:done', finish, { once: true });
        document.body.appendChild(flyElement);
      });
    });
  }

  /**
   * @param {string} url
   * @returns {string}
   */
  function toJsonRoute(url) {
    if (url.endsWith('.js')) return url;
    return `${url.replace(/\/$/, '')}.js`;
  }

  function getRoutes() {
    const routes =
      typeof Theme !== 'undefined' && Theme?.routes
        ? Theme.routes
        : window.Theme?.routes || {};
    const cartUrl = routes.cart_url || '/cart';

    return {
      cartAddUrl: routes.cart_add_url || '/cart/add.js',
      cartUrl: toJsonRoute(cartUrl),
      cartPath: cartUrl,
    };
  }

  window.__productCardAddSubmit = submitProductCardAddForm;

  if (Array.isArray(window.__productCardAddQueue)) {
    const queuedForms = window.__productCardAddQueue.splice(0);
    queuedForms.forEach((form) => {
      if (form instanceof HTMLFormElement) submitProductCardAddForm(form);
    });
  }
})();
